import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Coins, Plus, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/AuthContext";

export default function PaymentHistory({ onBuy }) {
  const { user } = useAuth();
  const [txns, setTxns] = useState([]);
  useEffect(() => { api.get("/transactions").then(r => setTxns(r.data)).catch(() => {}); }, []);
  const totalSpent = txns.reduce((s, t) => s + (t.amount_rs || 0), 0);
  const totalCoins = txns.reduce((s, t) => s + (t.coins || 0), 0);

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        <div className="glass rounded-2xl p-6">
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Balance</div>
          <div className="font-display text-4xl font-black mt-2 flex items-center gap-2">
            <Coins className="w-6 h-6 text-primary" /> {user?.coins || 0}
          </div>
        </div>
        <div className="glass rounded-2xl p-6">
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Total bought</div>
          <div className="font-display text-4xl font-black mt-2">{totalCoins}<span className="text-lg font-semibold text-muted-foreground"> coins</span></div>
        </div>
        <div className="glass rounded-2xl p-6">
          <div className="text-xs uppercase tracking-widest text-muted-foreground font-semibold">Amount spent</div>
          <div className="font-display text-4xl font-black mt-2 text-primary">₹{totalSpent}</div>
        </div>
      </div>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display text-xl font-bold">Transactions</h3>
        <Button onClick={onBuy} data-testid="history-buy-btn" className="rounded-full bg-primary hover:bg-primary/90 h-11">
          <Plus className="w-4 h-4 mr-1.5" /> Buy coins
        </Button>
      </div>
      {txns.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center text-muted-foreground">No transactions yet.</div>
      ) : (
        <div className="glass rounded-2xl divide-y divide-border" data-testid="txn-list">
          {txns.map(t => (
            <div key={t.txn_id} className="flex items-center justify-between p-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <CheckCircle2 className="w-5 h-5 text-primary" />
                </div>
                <div>
                  <div className="font-medium">Bought {t.coins} coins</div>
                  <div className="text-xs text-muted-foreground">
                    {new Date(t.created_at).toLocaleString()} · {t.mode === "MOCKED" ? "Test mode" : "Razorpay"}
                  </div>
                </div>
              </div>
              <div className="text-right">
                <div className="font-display font-bold text-lg">₹{t.amount_rs}</div>
                <div className="text-xs text-muted-foreground">Success</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
